import { render, staticRenderFns } from "./wufu2020.vue?vue&type=template&id=c64ec174&scoped=true&"
import script from "./wufu2020.vue?vue&type=script&lang=js&"
export * from "./wufu2020.vue?vue&type=script&lang=js&"
import style0 from "./wufu2020.vue?vue&type=style&index=0&id=c64ec174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64ec174",
  null
  
)

export default component.exports